export enum LocalStorageEnum {
  CURRENT_LANGUAGE_LOCALE_STORAGE_KEY = 'language',
  USER_INFO_STORAGE_KEY = 'userProfile',
  USER_PERMISSIONS_STORAGE_KEY = 'userPermission',
  ID_TOKEN_STORAGE_KEY = 'idToken',
}
